module.exports = __webpack_public_path__ + "img/csv-file-icon.7d095956.svg";